module.exports = __webpack_public_path__ + "img/img7.d8c532dd.jpg";